"use strict";

import angular from "angular";

import { Company } from "../../gateway/Company/Company";
import { Serie } from "../../gateway/Serie/Serie";
import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { Events } from "../../presentation/services/Events/Events";
import { GetCompaniesByIdsAndFilterUsecase } from "../../usecases/get-companies-by-ids-and-filter.usecase";
import { loadingDialogTemplate } from "../../views/accounting/company/dashboards/dashboards.dialog-templates";
import notifyErrorDialogTemplate from "../dialogs/notify-error/notify-error-dialog.html";

export class ParameterizationProcessService {
    Serie = new Serie();
    Company = new Company();
    Events = new Events();
    user = new UserDataAdapter().user();
    processing = false;
    shouldStopPolling = false;
    statesDisabled = [
        "nucont.accounting.company.dataRedirect",
        "nucont.accounting.company.dashboards.view",
        "nucont.accounting.company.monitoring.audit",
        "nucont.accounting.company.accountsPlan",
        "nucont.accounting.company.demonstrationsRedirect",
        "nucont.accounting.company.monitoring.health",
        "nucont.accounting.company.projection",
        "nucont.accounting.company.budget",
        "nucont.accounting.company.reports",
        "nucont.accounting.company.parameterizationOnDemand"
    ];
    companyStarted = {};

    constructor(
        NavigationService,
        CompanyDataService,
        DesnuDialogService,
        AccountingDataService,
        $rootScope,
        $state,
        AccountingPlanService
    ) {
        this.NavigationService = NavigationService;
        this.CompanyDataService = CompanyDataService;
        this.DesnuDialogService = DesnuDialogService;
        this.AccountingDataService = AccountingDataService;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.AccountingPlanService = AccountingPlanService;
    }

    init() {
        const company = this.CompanyDataService.get();
        if (!company) return;
        const isProcessing =
            company.props.autoAssociated?.status === "PROCESSING";
        this.shouldStopPolling = false;
        this.setProcessing(isProcessing);
    }

    async start() {
        if (!this.AccountingPlanService.features["AutomaticParameterization"]) {
            return;
        }
        const isBusinessmanUser = this.user.roles.includes("Empresa");
        if (isBusinessmanUser) return;
        const company = this.CompanyDataService.get();
        if (!company) return;
        const response = await this.Serie.hasAssociated({
            companyId: company.props._id
        });
        if (!company.props.autoAssociated?.status) {
            const seriesIsAllowedToParameterize =
                response?.hasSeries && !response?.hasAssociated;
            if (seriesIsAllowedToParameterize) {
                this.shouldStopPolling = false;
                this.CompanyDataService.setAttribute("autoAssociated", {
                    status: "PROCESSING",
                    lastUpdate: new Date()
                });
                this.Events.send("empresa.parametrizacaoautomatica.iniciada");
                this.setProcessing(true);
                this.callAssociated();
                this.openLoadingDialog();
            }
        } else if (company.props.autoAssociated?.status === "PROCESSING") {
            this.Events.send(
                "empresa.parametrizacaoautomatica.continuar.processando"
            );
            this.openLoadingDialog();
            this.checkFinishAutoAssociated();
        } else if (company.props.autoAssociated?.status === "ERROR") {
            this.Events.send("empresa.parametrizacaoautomatica.continuar.erro");
            this.onCompanyHasError(company);
        }
    }

    onCompanyHasError(company) {
        if (
            company.props.autoAssociated?.viewAudit === false ||
            company.props.autoAssociated?.viewError === false
        ) {
            let type = "";
            if (company.props.autoAssociated?.viewError === false) {
                type = "NOT_SUCCESS";
            }
            if (company.props.autoAssociated?.viewAudit === false) {
                type = "NOT_AUDIT";
            }
            this.notifyError(type);
        }
    }

    async callAssociated() {
        const company = this.CompanyDataService.get();
        if (!company) return;
        this.companyStarted = angular.copy(company);
        console.time("AUTO_ASSOCIATED_ACCOUNTS");
        const response = await this.Serie.autoAssociatedAccounts({
            companyId: company.props._id
        });
        console.timeEnd("AUTO_ASSOCIATED_ACCOUNTS");
        this.afterFinishAssociated(response);
    }

    afterFinishAssociated(response) {
        if (this.shouldStopPolling) {
            console.log("FINISHED AWAIT, BUT STOPED");
            return;
        }
        const company = this.CompanyDataService.get();
        if (this.companyStarted.props._id != company.props._id) {
            console.log("FINISHED AWAIT, BUT COMPANY IS DIFF");
            return;
        }
        this.setProcessing(false);
        if (response.error) {
            this.notifyError("ERROR");
            this.CompanyDataService.setAttribute(
                "autoAssociated.status",
                "ERROR"
            );
            this.Events.send(
                "empresa.parametrizacaoautomatica.finalizado.erro"
            );
        } else if (!response.success) {
            this.notifyError("NOT_SUCCESS");
            this.CompanyDataService.setAttribute(
                "autoAssociated.status",
                "ERROR"
            );
            this.Events.send(
                "empresa.parametrizacaoautomatica.finalizado.semsucesso"
            );
        } else if (!response.audit) {
            this.notifyError("NOT_AUDIT");
            this.CompanyDataService.setAttribute(
                "autoAssociated.status",
                "COMPLETED"
            );
            this.Events.send(
                "empresa.parametrizacaoautomatica.finalizado.naoauditado"
            );
        } else {
            this.$rootScope.$broadcast("CLOSE_PARAMETERIZATION_DIALOG");
            this.CompanyDataService.setAttribute(
                "autoAssociated.status",
                "COMPLETED"
            );
            this.Events.send(
                "empresa.parametrizacaoautomatica.finalizado.sucesso"
            );
        }
        this.$rootScope.$broadcast("FINISH_AUTO_ASSOCIATED_ACCOUNTS", {
            status: "COMPLETED"
        });
    }

    openLoadingDialog() {
        this.DesnuDialogService.custom({
            controller: "LoadingDialogCtrl",
            clickOutsideToClose: false,
            escapeToClose: false,
            locals: {
                templateHtml: loadingDialogTemplate
            },
            after: {
                hide: () => {}
            }
        });
    }

    notifyError(type) {
        const messages = {
            ERROR: {
                contentTitle: "Parametrização não concluída",
                description:
                    "Não foi possível realizar a parametrização automática das contas da empresa.",
                button: {
                    label: "Fechar"
                }
            },
            NOT_SUCCESS: {
                contentTitle: "Parametrização não concluída",
                description:
                    "Não foi possível realizar a parametrização automática das contas da empresa. <br /> Realize a parametrização manualmente para continuar a análise.",
                button: {
                    label: "Parametrizar manualmente"
                }
            },
            NOT_AUDIT: {
                contentTitle: "Parametrização não concluída",
                description:
                    "Foram encontradas diferenças nas contas da empresa. </br> Verifique os dados e realize a parametrização manualmente para continuar a análise.",
                button: {
                    label: "Verificar dados"
                }
            }
        };
        const message = messages[type];
        if (!message) return;
        const accounting = this.AccountingDataService.getEntity();
        const company = this.CompanyDataService.get();
        this.Company.updateFields(accounting.props._id, company.props._id, {
            autoAssociated: {
                viewAudit: true,
                viewError: true
            }
        });
        this.CompanyDataService.setAttribute("autoAssociated.viewAudit", true);
        this.CompanyDataService.setAttribute("autoAssociated.viewError", true);
        this.DesnuDialogService.custom({
            controller: "NotifyErrorDialogCtrl",
            locals: {
                width: "524px",
                templateHtml: notifyErrorDialogTemplate,
                contentTitle: message.contentTitle,
                description: message.description,
                button: message.button
            },
            after: {
                hide: () => {
                    if (type === "NOT_AUDIT") {
                        this.$state.go(
                            "nucont.accounting.company.department.accounting.import"
                        );
                    } else {
                        this.$state.go(
                            "nucont.accounting.company.parameterizationOnDemand"
                        );
                    }
                }
            }
        });
    }

    async checkFinishAutoAssociated() {
        const company = this.CompanyDataService.get();

        // Reseta a flag de parada ao iniciar o polling
        this.shouldStopPolling = false;

        // Loop de polling para verificar o status
        let isProcessing = true;
        let loopCount = 0;
        const maxLoops = 30;

        while (
            isProcessing &&
            loopCount < maxLoops &&
            !this.shouldStopPolling
        ) {
            const getCompaniesByIdsAndFilterUsecase =
                new GetCompaniesByIdsAndFilterUsecase();
            const response = await getCompaniesByIdsAndFilterUsecase.execute({
                companyIds: [company.props._id]
            });
            loopCount++;

            // Verifica se foi solicitado parar o polling
            if (this.shouldStopPolling) {
                isProcessing = false;
                break;
            }

            // Verifica se há resposta e se o status é PROCESSING
            if (response && response.length > 0) {
                const companyData = response[0];
                const status = companyData?.autoAssociated?.status;

                if (status === "PROCESSING") {
                    // Verifica se atingiu o limite de loops
                    if (loopCount >= maxLoops) {
                        // Timeout: trata como erro
                        this.CompanyDataService.setAttribute(
                            "autoAssociated.status",
                            "COMPLETED"
                        );
                        this.$rootScope.$broadcast(
                            "CLOSE_PARAMETERIZATION_DIALOG"
                        );
                        this.$rootScope.$broadcast(
                            "FINISH_AUTO_ASSOCIATED_ACCOUNTS",
                            {
                                status: "COMPLETED"
                            }
                        );
                        this.setProcessing(false);
                        this.Events.send(
                            "empresa.parametrizacaoautomatica.continuar.finalizado.timeout"
                        );
                        isProcessing = false;
                    } else {
                        // Aguarda 30 segundos antes da próxima chamada
                        await new Promise((resolve) =>
                            setTimeout(resolve, 30000)
                        );
                    }
                } else {
                    // Status mudou, sai do loop
                    isProcessing = false;

                    // Atualiza os dados da empresa no serviço
                    if (companyData?.autoAssociated) {
                        this.CompanyDataService.setAttribute(
                            "autoAssociated",
                            companyData.autoAssociated
                        );

                        // Processa o resultado final
                        if (status === "COMPLETED") {
                            this.Events.send(
                                "empresa.parametrizacaoautomatica.continuar.finalizado.sucesso"
                            );
                            this.setProcessing(false);
                            this.$rootScope.$broadcast(
                                "CLOSE_PARAMETERIZATION_DIALOG"
                            );
                        } else if (status === "ERROR") {
                            this.Events.send(
                                "empresa.parametrizacaoautomatica.continuar.finalizado.erro"
                            );
                            this.setProcessing(false);
                            const company = this.CompanyDataService.get();
                            this.onCompanyHasError(company);
                        }
                        this.$rootScope.$broadcast(
                            "FINISH_AUTO_ASSOCIATED_ACCOUNTS",
                            {
                                status: "COMPLETED"
                            }
                        );
                    }
                }
            } else {
                // Sem resposta válida, sai do loop
                isProcessing = false;
            }
        }
    }

    stopCheckFinishAutoAssociated() {
        this.shouldStopPolling = true;
    }

    stopMain;

    setProcessing(processing) {
        this.processing = processing;
        if (this.processing) {
            this.disableStates();
        } else {
            this.enableStates();
        }
    }

    disableStates() {
        this.NavigationService.setDisabled(this.statesDisabled);
    }

    enableStates() {
        this.NavigationService.setEnabled(this.statesDisabled);
    }

    isProcessing() {
        return this.processing;
    }

    getStatus() {
        const company = this.CompanyDataService.get();
        return company.props.autoAssociated?.status;
    }
}

angular
    .module("nucont.shared")
    .service("ParameterizationProcessService", [
        "NavigationService",
        "CompanyDataService",
        "DesnuDialogService",
        "AccountingDataService",
        "$rootScope",
        "$state",
        "AccountingPlanService",
        ParameterizationProcessService
    ]);
